module.exports = require('./helpers/bundle-url').getBundleURL('hcTqB') + "mobileSubjectBackground.48cea1d5.jpg";